<template>
  <div
    class="flex items-center rounded"
    :class="alertRoot"
    v-on="$listeners"
    v-bind="$attrs">  
    
    <span class="mr-4" :class="alertIcon">
      <template v-if="type == 'success'">
        <Icon name="check-circle" />
      </template>
      <template v-if="type == 'error'">
        <Icon name="times-circle" />
      </template>
      <template v-if="type == 'warning'">
        <Icon name="exclamation-circle" />
      </template>
      <template v-if="type == 'info'">
        <Icon name="info-circle" />
      </template>
    </span>

    <span :class="alertTitle">
      <slot />
    </span>

  </div>
</template>

<script>

import Icon from '../Icon'

export default {
  name: 'Alert',

  components: {Icon},

  props: {

    box: {
      type: String,
      default: 'pane'
    },

    type: {
      type: String,
      default: 'error',
      validator: v => [
        'success',
        'error',
        'warning',
        'info'
      ].includes(v)
    }

  },

  computed: {

    alertRoot () {
      return [{
        [ this.$style.success ]: this.type == 'success',
        [ this.$style.error ]: this.type == 'error',
        [ this.$style.warning ]: this.type == 'warning',
        [ this.$style.info ]: this.type == 'info',
        [ this.$style.pane ]: this.box == 'pane',
        [ this.$style.line ]: this.box == 'line'
      }]
    },

    alertIcon () {
      return [
        this.$style.alertIcon
      ]
    },

    alertTitle () {
      return [
        'text-sm',
        this.$style.alertTitle
      ]
    }

  }

}

</script>

<style module>

  .error {
    @apply
      bg-danger-light
  }

  .error .alertIcon {
    @apply
      text-danger
  }

  .error .alertTitle {
    @apply
      text-danger-dark
  }

  .warning {
    @apply
      bg-warning-light
  }

  .warning .alertIcon {
    @apply
      text-warning
  }

  .warning .alertTitle {
    @apply
      text-warning-dark
  }

  .success {
    @apply
      bg-success-light
  }

  .success .alertIcon {
    @apply
      text-success
  }

  .success .alertTitle {
    @apply
      text-success-dark
  } 

  .info {
    @apply
      bg-dull-light
  }

  .info .alertIcon {
    @apply
      text-dull
  }

  .info .alertTitle {
    @apply
      text-dull-dark
  }

  .line {
    @apply
      bg-transparent
  }

  .pane {
    @apply
      p-4
  }

</style>
